import { ReactElement } from "react";
import { IoIosCheckmarkCircle } from "react-icons/io";
import {Modal} from "@/widgets/Modal";
import {Button} from "@/components/buttons/Button";
import { IoClose } from "react-icons/io5";
import {BlinkBlur} from "react-loading-indicators";

interface NftPromoModalLoadingProps {
    loading: true;
    isOpen: boolean;
    onClose: () => void;
}

interface NftPromoModalReadyProps {
    loading: false;
    isOpen: boolean;
    image: string;
    dateMinted: Date;
    description: string;
    nftName?: string;
    onOpenRewardsDrawer?: () => void;
    onClose: () => void;
}

type NftPromoModalProps = NftPromoModalLoadingProps | NftPromoModalReadyProps;

export const NftPromoModal = (props: NftPromoModalProps) => {
    /*
     * Annotated ReactElement so the children tuple carries a flat element type.
     * Inferring it trips TS2589 in full-program runs: the checker's comparison
     * walks into abitype's recursive tuple utils (utils.d.ts:76, via thirdweb)
     * and exhausts its instantiation depth at this site.
     */
    const loadingIndicator: ReactElement = <BlinkBlur color="rgba(163, 163, 163, 1)" size="medium" text="" textColor="" />;

    if (props.loading) {
        return (
            <Modal contentClassName="nft-promo-modal" isOpen={props.isOpen} toggle={props.onClose}>
                <div className="nft-promo-modal_loading_container">
                    <h4 className="nft-promo-modal_loading_cta">
                        Hang Tight!
                    </h4>
                    <div className="nft-promo-modal_loading_description">Your reward is coming your way! Please give a couple of seconds. Thank you.</div>
                    {loadingIndicator}
                </div>
            </Modal>
        );
    }

    const {dateMinted, image, description, nftName, isOpen, onClose, onOpenRewardsDrawer} = props as NftPromoModalReadyProps;

    const dateMintedString = dateMinted.toLocaleDateString("en-US", { year: "numeric",
        month: "short",
        day: "numeric" });

    const onClickRedeemNow = () => {
        // Open the rewards drawer to redeem LootBox
        if (onOpenRewardsDrawer) {
            onOpenRewardsDrawer();
        }
        onClose(); // Close the modal
    };


    return (
        <Modal
            contentClassName="nft-promo-modal"
            isOpen={isOpen}
            toggle={onClose}
        >
            <div className="nft-promo-modal_container">
                <div
                    className="nft-promo-modal_x-button"
                    onClick={onClose}
                >
                    <IoClose size={24}/>
                </div>
                <img
                    src={image}
                    alt={"Promo Minted"}
                    className="nft-promo-modal_img"
                />
                <div>
                    <h4 className="nft-promo-modal_cta">
                        {nftName || "NFT Tracker"} Claimed <span className="nft-promo-modal_cta_span"><IoIosCheckmarkCircle size={20}/></span>
                    </h4>
                    <p className="nft-promo-modal_mint-date">Claimed on {dateMintedString}</p>
                </div>
                <p className="nft-promo-modal_description">{description}</p>
                <Button variant="primary"
                    className="nft-promo-modal_use-promo-button"
                    onClick={onClickRedeemNow}
                >
                    <span className="nft-promo-modal_use-promo-button_text">Redeem Now</span>
                </Button>
                <Button variant="ghost"
                    className="nft-promo-modal_close-secondary-button"


                    onClick={onClose}
                >
                    <span className="nft-promo-modal_close-secondary-button_text">Close</span>
                </Button>
            </div>
        </Modal>
    );
};